import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { iconLoader, iconLogo } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon } from '../icon/icon.js';
export var Loader = function Loader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      show = _ref.show,
      fullscreen = _ref.fullscreen,
      rest = _objectWithoutProperties(_ref, ["className", "label", "show", "fullscreen"]);

  return React.createElement("div", _objectSpread({
    "aria-busy": show ? 'true' : undefined,
    "aria-hidden": !show,
    "aria-label": label || 'Loading',
    "aria-live": show ? 'polite' : undefined,
    className: cx('tds-loader', {
      'tds-loader--show': show,
      'tds-loader--fullscreen': fullscreen
    }, className),
    role: show ? 'progressbar' : undefined
  }, rest), React.createElement(Icon, {
    data: iconLoader
  }), React.createElement(Icon, {
    data: iconLogo
  }));
};